import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, Flex, Text } from "@chakra-ui/react";

import { actions as CasesAction, selectors } from "@containers/Cases/store";
import { deleteCase } from "@containers/Cases/store/actions";
import { CaseModel } from "@shared/models";
import { getFullName } from "@shared/utils";
import { defaultFilter } from "@containers/Cases/store/reducer";

interface DeleteCaseModalProps {
  onClose: () => void;
  item: CaseModel;
}

const DeleteCaseModal: FC<DeleteCaseModalProps> = ({ item, onClose }) => {
  const dispatch = useDispatch();
  const filter = useSelector(selectors.getFilter());

  const handleDeleteCase = () => {
    dispatch(
      deleteCase.request({
        caseId: item.id,
        cb: () => {
          dispatch(CasesAction.setFilter({ ...filter, page: defaultFilter.page, limit: defaultFilter.limit }));
          onClose();
        },
      }),
    );
  };

  return (
    <>
      <Dialog.Header>
        <Text textStyle="subtitle">Remove Case</Text>
      </Dialog.Header>
      <Dialog.Body p={5}>
        <Text fontSize="14px" color="#9b9591" textAlign="left">
          {`Are you sure you want to remove ${getFullName<CaseModel>(item, "-")} case?`}
        </Text>
        <Flex mt={6} justify="flex-end" gap={3}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="primary" onClick={handleDeleteCase}>
            Delete
          </Button>
        </Flex>
      </Dialog.Body>
    </>
  );
};

export default DeleteCaseModal;
